import Loader from '../../../_modules/loader/loader';
import { displayErrors, isValidDetails } from './_helper';
import { toaster } from './_material';

if ($('.product').length) {
	let popupInterruptProductTmp = '',
	discontinuedWithReplacement = 'Discontinued with replacement',
	discontinuedWithoutReplacement = 'Discontinued without replacement',
	toBeDiscontinuedWithoutReplacement = 'To be discontinued with replacement',
	$form,
	$apiUrl,
	loader,
	isUpdate,
	$productThreshold = $('.product-thresholds');

	loader = new Loader();

	if($('.form--new-product').length){
		$form = $('.form--new-product');
		$apiUrl = '/api/products/create';
	}
	isUpdate = $('.form--update-product').length;

	if(isUpdate){
		$form = $('.form--update-product');
		$apiUrl = '/api/products/update';
		popupInterruptProductTmp = doT.template($('#popup-product-interrupt-tmp').html());
	}


	let productStatus = $('#Status :selected').text();
	if(productStatus === discontinuedWithReplacement || productStatus === toBeDiscontinuedWithoutReplacement){
		$('#Replacement')
			.attr('required', true)
			.closest('[class^="col-"]')
			.removeClass('vh--desktop');
		$productThreshold.addClass('show');
	} else {
		$productThreshold.removeClass('show');
	}

	// Display replacement dropdown if it is discontinued
	$('#Status').on('change', function (e) {
		e.preventDefault();

		let $this = $(this),
			$replacement = $('#Replacement'),
			$selected = $this.find('option:selected').text(),
			$institutionPayCutOffDate = $('#InstitutionPayCutOffDate');

		if($selected === discontinuedWithReplacement || $selected === toBeDiscontinuedWithoutReplacement){
			$replacement
				.attr('required', true)
				.closest('[class^="col-"]')
				.removeClass('vh--desktop');
				if($selected === toBeDiscontinuedWithoutReplacement) {
					$productThreshold.addClass('show');
				} else {
					$productThreshold.removeClass('show');	
				}
		}
		else{
			$institutionPayCutOffDate.val('');
			$replacement
				.attr('required', false)
				.trigger('change')
				.closest('[class^="col-"]')
				.addClass('vh--desktop');
			$productThreshold.removeClass('show');
		}

	});

	$(document).on('click', '.js-cancel-save-product', function(e){
      $.fancybox.close();
    });

	let saveProduct = function(){
		let $this = $('.js-save-product');

		let $errorContainer = $this.parent().siblings('.server-errors__wrap'),
			$fields = $form.find('input, select').filter(function(){
				return $(this).is(':visible') ||  this.id === "ProductId" || this.id === "ProductBrand" || this.id === "UnitofMeasurement";
			}),
			$requiredInputs = $fields.filter('[required]');

			//prevent API call if required inputs are empty
		if(isValidDetails($requiredInputs))
			$this.removeClass('error');
		else{
			$this.addClass('error');
			return false;
		}

		loader.fadeIn();

		//prepare image to upload, if any
		let formData = new FormData(),
			files = $("#ProductImage").get(0).files;

		// Add the uploaded image content to the form data collection
		if (files.length > 0) {
			formData.append("ProductImage", files[0]);
		}

		//prepare API values
		$fields.each( function(){
			let $this = $(this),
				propertyName = $this.attr('id'),
				value;

			if($this.is(":checkbox"))
				value = $this.prop('checked');
			else
				value = $this.val();

			formData.append(propertyName, value);
		});

		//check if we need to save threshold
		let productStatus = $('#Status :selected').text(),
			thresholds = [];
		if(productStatus === toBeDiscontinuedWithoutReplacement) {
			$(".threshold").each((idx, t)=>{
				let $t = $(t);
				thresholds.push({
					OrganisationCode: t.id,
					Quantity: $t.val()
				});
			});
			formData.append("Thresholds", JSON.stringify(thresholds));
		}
	

		$.ajax({
			url: $apiUrl,
			type: 'POST',
			headers: { __RequestVerificationToken: $form.find('input[name=__RequestVerificationToken]').val()  },
			processData: false,  // needed for uploading images
			contentType: false,
			data: formData,
			success: function (data) {

				toaster( 'Product successfully added!');

				loader.fadeOut();

				window.location.href = data.href;
			},
			error: function (error) {

				loader.fadeOut();
				displayErrors(error, $errorContainer );
			}
		});
	};

	$('.js-save-product').on('click', function(){
		if(isUpdate && $('#Status :selected').text() === discontinuedWithReplacement || $('#Status :selected').text() === discontinuedWithoutReplacement){

				let $errorContainer = $(this).parent().find('.server-errors__wrap');

						let	popupInterruptProductHtml = '',
						_regimens = [],
						isMobileDevice = Modernizr.mq('(max-width: 767px)'),
						dataParams = {
							"Id" : $('#ProductId').val(),
							"Replacement" : $('#Replacement').find('option:selected').val() == '' ? null : $('#Replacement').find('option:selected').val()
						};

						$.ajax({
							url: '/api/regimens/check',
							dataType: 'json',
							contentType: 'application/json; charset=utf-8',
							// Comment out for simulation.
							type: 'POST',
							headers: { __RequestVerificationToken: $('.form--update-product').find('input[name=__RequestVerificationToken]').val() },
							data: JSON.stringify(dataParams),
							success: function (data) {
								_regimens = data.regimens;
								if(_regimens.length){
									let obj = {},
											popupInterruptProductHtml = '';

												obj = {
														"regimens": _regimens
												};
												popupInterruptProductHtml += popupInterruptProductTmp(obj);
												$('.popup-product-interrupt').html(popupInterruptProductHtml);
												$.fancybox.open('#product-active', {
													autoSize: false,
													closeBtn: false,
													fitToView: false,
													height: isMobileDevice == true ? 300 : 200,
													width: isMobileDevice == true ? 250 : 500,
													padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
													type: 'inline',
													wrapCSS: 'modal',
													helpers: {
															overlay:{
																	closeClick: true
															}
													}
											});
									}else{
										//no regimens would be cancelled, no need to display interrupt
										//just submit the form
										saveProduct();
									}
							},
							error: function (error) {
									loader.fadeOut();
									displayErrors(error, $errorContainer );
							}
				});
		}
		else{
			saveProduct();
		}
	});

	$(document).on('click', '.js-continue-save-product', function(e){
		saveProduct();
	});
}
